export const FETCH_ASSOCIATES_DATA_REQUEST = 'FETCH_ASSOCIATES_DATA_REQUEST'
export const FETCH_ASSOCIATES_DATA_FAILURE = 'FETCH_ASSOCIATES_DATA_FAILURE'
export const FETCH_ASSOCIATES_DATA_SUCCESS = 'FETCH_ASSOCIATES_DATA_SUCCESS'
